import { apiRequest } from "@/api";

const state = {
  show_btn: false,
  credentials: undefined,
  shop: undefined,
  accessToken: undefined,
  shopInfos: undefined,
};

const mutations = {
  SET_ACCESS_INFOS: (state, data) => {
    if (data.response) {
      console.log("Shopify Access Infos", data.response);
      state.shop = data.response.name;
      state.credentials = data.response.credentials;
      state.show_btn = true;
      state.accessToken = data.response.credentials.accessInfos.access_token;
      state.shopInfos = data.response.credentials.shop;
    }
  },
  SET_NEW_INSTALL_KEY: (state, data) => {
    state.credentials.install_hmac = data.hmac;
  },
};

const actions = {
  SHOPIFY_INSTALL: ({ commit }, { shop, storeId, scopes }) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .get("shopify/shopify_installation", {
          params: { shop, storeId, scopes },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  SHOPIFY_KEY_CHECK: ({ commit }, { key }) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .get("shopify", {
          params: { key },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  SHOPIFY_GET_PRODUCTS: ({ commit }, { shop, accessToken }) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .post("shopify/products/getProducts", { shop, accessToken })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  FETCH_SHOPIFY_ACCESS_INFOS: ({ commit }) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .get("shopify/getAccessInfos")
        .then(({ data }) => {
          commit("SET_ACCESS_INFOS", data);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  GENERATE_NEW_INSTALL_KEY: ({ commit }, shop) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .post("shopify/generateInstallKey", shop)
        .then(({ data }) => {
          commit("SET_NEW_INSTALL_KEY", data);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
};
export default {
  state,
  actions,
  mutations,
};
